export default __webpack_public_path__ + "img/tbzgJkJi.ea315851.svg";